<form class="action-form" [formGroup]="form" (ngSubmit)="onSubmit()">
  <span class="title">{{ 'PRICELIST.IMPORT_SABO.TITLE' | translate }}</span>
  <div class="row form-group">
    <div class="col-12">
      <span>{{ 'PRICELIST.IMPORT_SABO.DESCRIPTION' | translate }}</span>
    </div>
  </div>
  <div class="row form-group">
    <div class="col-12">
      <app-text-box [control]="form.controls['name']"></app-text-box>
    </div>
    <div class="col-12">
      <app-single-file-upload (filesSelected)="onFileChange($event)"></app-single-file-upload>
      <span class="error">{{ errorMessage | translate }}</span>
    </div>
  </div>
  <div class="row">
    <div class="col-12">
      <button class="btn btn-active" [ngClass]="{ disabled: disabled }" [disabled]="disabled" type="submit">
        {{ 'PRICELIST.IMPORT_SABO.BUTTON' | translate }}
      </button>
      <button class="btn link-btn ml-2" (click)="close()">{{ 'CANCEL_BTN' | translate }}</button>
    </div>
  </div>
</form>
